import { preferencesConfigAction } from './actions';
import portfolioManagementStore from './store';

const portfolioManagementActions = {
  preferencesConfigAction,
};

export { portfolioManagementStore, portfolioManagementActions };
